import * as React from 'react'
import { ServiceLocationSection } from './ServiceLocationSection'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import { FieldArray } from 'formik'

type Props = {
  deleteServiceWarningMessage?: string
  disabled: boolean
  localMode: boolean
  serviceLocations: LocationDTO[]
  totalServicesCount?: number
  entityType: ENTITY_TYPES
  loading: boolean
  minimumServicesCount?: number
  readOnly?: boolean
  serviceFrequencies: IServiceFrequency[]
}

export function ServiceLocationList(props: Props) {
  const {
    deleteServiceWarningMessage,
    disabled,
    entityType,
    loading,
    localMode,
    minimumServicesCount,
    readOnly,
    serviceFrequencies,
    serviceLocations,
    totalServicesCount,
  } = props

  return (
    <FieldArray
      name="serviceIds"
      render={(arrayHelpers) =>
        serviceLocations.map((s, _index) => (
          <ServiceLocationSection
            arrayHelpers={arrayHelpers}
            defaultExpanded
            location={s}
            key={localMode ? s.externalLinkId : s.id}
            entityType={entityType}
            serviceFrequencies={serviceFrequencies}
            minimumServicesCount={minimumServicesCount}
            deleteServiceWarningMessage={deleteServiceWarningMessage}
            localMode={localMode}
            disabled={loading || disabled}
            readOnly={readOnly}
            loading={loading}
            totalServicesCount={totalServicesCount}
            serviceLocation={s}
            disableGrayBg
          />
        ))
      }
    />
  )
}
